import React from 'react';
import { connect } from 'react-redux';
import { getCMSObject, TeleScript } from 'sg-ui-components';
import { mapStateToProps, mapDispatchToProps } from '../Store';

import Layout from '../Components/Layout/Layout';
import PageTitle from '../Components/PageTitle.js';

const RulesPage = ({ user, config, cmsSourceFirebase, actions }) => {
    const page = {
        title: getCMSObject('data.microsite.general.rules.pageInfo.pageTitle'),
        className: 'rules',
    };

    return (
        <Layout {...{ page, user, config, cmsSourceFirebase, actions }}>
            <div className='page-info'>
                <PageTitle title={page?.title} />
            </div>
            <div className='static-content'>
                <TeleScript line={getCMSObject('data.microsite.general.rules.contentHTML')} />
            </div>
        </Layout>
    );
};

export default connect(mapStateToProps, mapDispatchToProps)(RulesPage);
